import { cn } from "@/lib/utils";

/**
 * A yes/no setting drawn as a switch: keep a position, show the client's name, show retired rows. A
 * checkbox stays the control for picking items out of a list; a switch is one setting with two states.
 */
export function Switch({
  checked,
  onChange,
  label,
  disabled,
  className,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  disabled?: boolean;
  className?: string;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={cn(
        "relative inline-block h-5 w-[34px] shrink-0 rounded-full border transition-colors",
        "focus-visible:ring-bank-accent focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:outline-none",
        "disabled:cursor-not-allowed disabled:opacity-50",
        checked ? "bg-bank-accent-strong border-transparent" : "border-bank-border-strong bg-bank-surface-3",
        className,
      )}
    >
      <span
        aria-hidden="true"
        className={cn(
          "absolute top-[3px] size-3 rounded-full transition-[left]",
          checked ? "bg-bank-on-accent left-[17px]" : "bg-bank-muted left-[3px]",
        )}
      />
    </button>
  );
}
